type ApiData = {
    api?: string;
}

const Prefix: ApiData = {
    api: 'api/v1',
};

export default Prefix;